import { Link } from 'react-router-dom';
import { ArrowUpRight } from '@phosphor-icons/react';
import { useSEO } from '../lib/seo';
import { Reveal, PageHero } from '../lib/motion';
import { GUIDES, GUIDES_INDEX } from '../data/guides';

const GuidesIndex = () => {
  useSEO({
    title: GUIDES_INDEX.title,
    description: GUIDES_INDEX.description,
    path: '/guides',
    jsonLd: {
      '@context': 'https://schema.org',
      '@type': 'CollectionPage',
      name: 'Industrial Service Guides',
      description: GUIDES_INDEX.description,
      url: 'https://voxmeridian.com/guides',
      isPartOf: { '@type': 'WebSite', name: 'Vox Meridian', url: 'https://voxmeridian.com' },
    },
  });

  return (
    <div className="bg-ink" data-testid="guides-index">
      <PageHero
        eyebrow="Guides"
        lines={['Industrial service guides,', 'in plain English.']}
        sub="Practical guides on RFQs, calibration, maintenance and contractor compliance — written for the people who buy and manage industrial services."
      />

      <section className="border-b border-line bg-ink">
        <div className="mx-auto max-w-7xl px-6 py-20 lg:px-10">
          <div className="grid gap-6 md:grid-cols-2">
            {GUIDES.map((g, i) => (
              <Reveal key={g.slug} delay={i * 0.05}>
                <Link
                  to={`/guides/${g.slug}`}
                  data-testid={`guide-card-${g.slug}`}
                  className="group flex h-full flex-col justify-between border border-line bg-surface p-8 transition-colors duration-300 hover:border-volt/60"
                >
                  <div>
                    <p className="mono-label text-volt">{g.keyword}</p>
                    <h2 className="mt-4 font-display text-2xl font-black leading-tight tracking-tight text-parchment transition-colors duration-200 group-hover:text-volt">
                      {g.h1.join(' ')}
                    </h2>
                    <p className="mt-4 text-base leading-relaxed text-steel">{g.lead}</p>
                  </div>
                  <div className="mt-8 flex items-center justify-between">
                    <span className="mono-label text-steel">{g.readTime}</span>
                    <span className="flex items-center gap-2 font-mono text-[11px] font-bold uppercase tracking-[0.15em] text-volt">
                      Read guide
                      <ArrowUpRight size={14} weight="bold" className="transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                    </span>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default GuidesIndex;
